// import { Svg } from 'components'
// import errorIcon from 'assets/icons/outline/exclamation.svg'

export const getError = (errors, path) => {
  let field
  if (Array.isArray(path)) {
    field = errors.find(err => err.key.every((val, k) => path[k] === val))
  } else {
    field = errors.find(err => err.key[0] === path)
  }
  if (field) return field.message
}

export const validate = (schema, data) => {
  const validation = schema.validate(data, { abortEarly: false })
  if (!validation.error) return
  return validation.error.details.map(detail => {
    return {
      key: detail.path,
      message: detail.message
    }
  })
}

export const displayErrors = errs => {
  // If the errors are just an array the show on mutiple lines
  if (Array.isArray(errs)) {
    return errs.map(err => {
      return m('p.text-red-800.m-1', err)
    })
  // If the errors are am object then they should be modelstate errors
  // We aren't handling them at field level yet so just iterate through all the values and show them all in one place
  } else if (typeof errs === 'object' && errs !== null) {
    return Object.keys(errs).map(k => {
      return m('p.text-red-800.m-1', errs[k])
    })
  // Deal with just a string error
  } else {
    return m('p.text-red-800.m-1', errs)
  }
}
